import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MaterialModule } from 'src/app/core/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CollectOptionsComponent } from './collect-options.component';
import { SearchPlaceComponentModule } from '../my-commerce/components/search-place/search-place.module';

@NgModule({
  declarations: [CollectOptionsComponent],
  exports: [CollectOptionsComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: CollectOptionsComponent
      }
    ]),
    MaterialModule,
    SharedModule,
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    TranslateModule.forChild({
      isolate: false
    }),
    FormsModule,
    ReactiveFormsModule,
    SearchPlaceComponentModule
  ],
  providers: [provideNgxMask()]
})
export class CollectOptionsModule {}
